var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resourcePDF"},[_c('iframe',{ref:"docFrame",staticClass:"resourcePDFUrl",attrs:{"id":_vm.frameId,"src":_vm.docUrl,"allowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }